import { RuleSearchType } from '../rules.types';
import {
    AutomationConditionNode,
    AutomationConnectionNode,
    AutomationCoreNode,
    AutomationEffectNode
} from './AutomationsNodes';

export enum RuleMethod {
    Noop = 'noop',
    DeliberateCrash = 'deliberateCrash',
    AddMemberToSegment = 'addMemberToSegment',
    RemoveMemberFromSegment = 'removeMemberFromSegment',
    GrantPerkFromImpact = 'grantPerkFromImpact',
    RevokeFromImpact = 'revokeFromImpact',
    UnverifyManyFromImpact = 'unverifyManyFromImpact',
    CreateScheduledTask = 'createScheduledTask'
}

export function isRuleMethod(item: any): item is RuleMethod {
    return Object.values(RuleMethod).includes(item);
}

export enum ENodeType {
    Core = 'core',
    Condition = 'condition',
    And = 'and',
    Effect = 'effect',
    Rule = 'rule'
}

export const automationNodeTypes = {
    [ENodeType.Core]: AutomationCoreNode,
    [ENodeType.Condition]: AutomationConditionNode,
    [ENodeType.And]: AutomationConnectionNode,
    [ENodeType.Effect]: AutomationEffectNode,
    [ENodeType.Rule]: AutomationConditionNode
};

export interface AutomationSearchFormValues {
    search: string;
    type: RuleSearchType;
}
